












































import { defineComponent, computed, PropType } from '~/utils/nuxt3-migration'
import BackgroundJobsBadge from '~/components/car/classifieds/search/results/rows/main/partials/BackgroundJobs/BackgroundJobsBadge.vue'
import BuyOnlineBadge from '~/components/car/classifieds/badges/BuyOnlineBadge.vue'
import ParkedPriceBadge from '~/components/shared/parking/badges/ParkedPriceBadge.vue'
import AuditedBadge from '~/components/car/classifieds/badges/AuditedBadge.vue'
import DealersOnlyBadge from '~/components/car/classifieds/badges/DealersOnlyBadge.vue'
import RequestsWorkBadge from '~/components/car/classifieds/badges/RequestsWorkBadge.vue'
import RequestsEmployeeBadge from '~/components/car/classifieds/badges/RequestsEmployeeBadge.vue'
import WantedBadge from '~/components/car/classifieds/badges/WantedBadge.vue'
import ForRentBadge from '~/components/car/classifieds/badges/ForRentBadge.vue'
import DamagedBadge from '~/components/car/classifieds/badges/DamagedBadge.vue'
import NewBadge from '~/components/car/classifieds/badges/NewBadge.vue'
import LeasingBadge from '~/components/car/classifieds/badges/LeasingBadge.vue'
import InstallmentsBadge from '~/components/car/classifieds/badges/InstallmentsBadge.vue'
import WithoutVatBadge from '~/components/car/classifieds/badges/WithoutVatBadge.vue'
import ForeignNumbersBadge from '~/components/car/classifieds/badges/ForeignNumbersBadge.vue'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { OfferType } from '~/models/classified/types'
import { CategoryId } from '~/models/category/types'
import PaidClassifiedBadge from '~/components/car/classifieds/badges/PaidClassifiedBadge.vue'
import { ClassifiedSearchResultRow } from '~/models/search/types'

export default defineComponent({
  components: {
    PaidClassifiedBadge,
    CBadge,
    ForeignNumbersBadge,
    WithoutVatBadge,
    BackgroundJobsBadge,
    BuyOnlineBadge,
    ParkedPriceBadge,
    AuditedBadge,
    DealersOnlyBadge,
    RequestsWorkBadge,
    RequestsEmployeeBadge,
    WantedBadge,
    ForRentBadge,
    DamagedBadge,
    NewBadge,
    LeasingBadge,
    InstallmentsBadge
  },
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    },
    classifiedBackgroundJobs: {
      type: Object,
      default: null
    },
    showPaymentBadge: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isJobClassified = props.classified.categoryIds.includes(
      CategoryId.JOBS
    )
    const isJobWantedClassified = props.classified.categoryIds.includes(
      CategoryId.JOBS_WANTED
    )
    const isRentalClassified = props.classified.categoryIds.includes(
      CategoryId.RENTALS
    )
    const isWanted = props.classified.offertype === OfferType.WANTED

    const isDamaged = computed(
      () => props.classified.damaged || props.classified.crashed
    )

    const hasZeroInterest = computed(() => {
      if (!props.classified.hasFinance || !props.classified.financeOptions) {
        return false
      }

      return props.classified.financeOptions.interest === 0
    })

    const isForRent = computed(
      () => props.classified.offertype === OfferType.RENT
    )

    return {
      isRentalClassified,
      isWanted,
      isJobClassified,
      isJobWantedClassified,
      isForRent,
      isDamaged,
      hasZeroInterest
    }
  }
})
